module.exports = __webpack_public_path__ + "img/review-logo.5d12cc95.png";